module.exports = __webpack_public_path__ + "img/auth-logo.31f83c31.png";